import { UnreachableI18nCaseError } from './i18nUtils';
export const canRejectApproval = ({
  approvalType
}) => {
  switch (approvalType) {
    case 'DEAL':
    case 'QUOTE':
    case 'CONNECTED_APP':
      return true;
    case 'MARKETING_EMAIL':
    case 'LANDING_PAGE':
    case 'SITE_PAGE':
    case 'BLOG_POST':
    case 'KNOWLEDGE_ARTICLE':
    case 'SOCIAL_BROADCAST':
      return false;
    default:
      throw new UnreachableI18nCaseError(approvalType);
  }
};